import { gql, useMutation, useReactiveVar } from '@apollo/client'
import * as Sentry from '@sentry/react'
import { timestampVar } from 'config/apollo/competitor-pricing/variables'
import { COMPETITOR_PRICING_QUERY } from 'components/station/components/competitor-pricing/CompetitorPricingQueries'
import { usePricingTypes } from 'components/common/hooks/usePricingTypes'
import { useShowToast } from 'components/common/hooks/useShowToast'

const DELETE_STATION_STRATEGY_MUTATION = gql`
  mutation deleteStationStrategyMutation(
    $stationId: ID!
    $stationStrategyId: ID!
  ) {
    deleteStationStrategy(
      input: { stationId: $stationId, stationStrategyId: $stationStrategyId }
    ) {
      error
    }
  }
`

function useDeleteStationStrategy(stationId, onSuccess) {
  const timestamp = useReactiveVar(timestampVar)
  const { supportedPricingTypes } = usePricingTypes()
  const { showErrorToast } = useShowToast()
  const [deleteStrategy, result] = useMutation(
    DELETE_STATION_STRATEGY_MUTATION,
    {
      update(
        cache,
        {
          data: {
            deleteStationStrategy: { error },
          },
        }
      ) {
        if (error) {
          showErrorToast()
          return
        }

        const variables = {
          stationId,
          supportedPricingTypes,
          timestamp,
        }
        const { station } = cache.readQuery({
          query: COMPETITOR_PRICING_QUERY,
          variables,
        })

        const updatedStation = { ...station, stationStrategy: null }
        cache.writeQuery({
          query: COMPETITOR_PRICING_QUERY,
          variables,
          data: { station: updatedStation },
        })
      },
      onCompleted({ deleteStationStrategy: { error } }) {
        if (!error) {
          onSuccess()
        }
      },
      onError(error) {
        Sentry.captureException(error)
        showErrorToast()
      },
    }
  )

  return [deleteStrategy, result]
}

export { useDeleteStationStrategy, DELETE_STATION_STRATEGY_MUTATION }
